import { useCallback } from 'react'
import { useUpdateUser } from '../../../../apiLayer'
import { useUser } from '../../../../hooks/useUser'

/** Records once that they have read the feedback of this game. */
export const useMarkLatestFeedbackRead = (sessionId: string | undefined) => {
  const { data: user } = useUser()
  const { mutate, isPending } = useUpdateUser()
  const readSessionId = user?.tasks?.latestSessionFeedback?.sessionId

  return useCallback(() => {
    const isAlreadyRead = readSessionId === sessionId
    if (!sessionId || !user?.id || isAlreadyRead || isPending) return

    mutate({
      id: user.id,
      userData: { tasks: { latestSessionFeedback: { sessionId, at: new Date().toISOString() } } }
    })
  }, [sessionId, user?.id, readSessionId, isPending, mutate])
}

/** Records the games their profile is built from as read. */
export const useMarkProfileFeedbackRead = () => {
  const { data: user } = useUser()
  const { mutate, isPending } = useUpdateUser()
  const sessionIds = user?.profileReport?.generatedFromSessionIds

  return useCallback(() => {
    if (!sessionIds?.length || !user?.id || isPending) return

    mutate({
      id: user.id,
      userData: { tasks: { profileFeedback: { sessionIds, at: new Date().toISOString() } } }
    })
  }, [sessionIds, user?.id, isPending, mutate])
}
